import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { HasSessionGuard } from 'src/app/shared/guards/has-session.guard';
import { SignUpComponent } from './sign-up/sign-up.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RegisterComponent } from './register/register.component';
import { LogoutComponent } from './logout/logout.component';
import { SessionLayoutComponent } from './session-layout.component';
import { CreateDealerComponent } from './create-dealer/create-dealer.component';
import { AuthorizationComponent } from './authorization/authorization.component';
import { DealerUnauthorizedComponent } from './dealer-unauthorized/dealer-unauthorized.component';
import { LoginADAuthCallbackComponent } from './login-ad/login-ad-auth.component';


const routes: Routes = [
  {
    path: '',
    component: SessionLayoutComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [HasSessionGuard]
      },
      {
        path: 'login-ad-auth',
        component: LoginADAuthCallbackComponent,
      },
      {
        path: 'sign-up',
        component: SignUpComponent,
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent
      },
      {
        path: 'login/resetPassword',
        component: ResetPasswordComponent
      },
      {
        path: 'login/verification',
        component: RegisterComponent
      },
      {
        path: 'create-dealer',
        component: CreateDealerComponent
      },
      {
        path: 'logout',
        component: LogoutComponent
      },
      {
        path: 'authorization',
        component: AuthorizationComponent
      },
      {
        path: 'dealer-unauthorized',
        component: DealerUnauthorizedComponent,
        data: {
          status: 'WAITING'
        }
      },
      {
        path: 'dealer-denied',
        component: DealerUnauthorizedComponent,
        data: {
          status: 'DENIED'
        }
      },
      {
        path: '',
        redirectTo: '/arrematar/maquinas',
        pathMatch: 'full'
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SessionRoutingModule { }
